/**
 * Spell a small count as a word.
 *
 * The onboarding flow numbers things the resident has to find: compartment 4,
 * circuit 2, port 3. A digit next to the same noun for a *quantity* reuses the
 * pattern they have learned to read as a label, so "2 compartments to go" reads
 * as "go to compartment 2". Words cannot be misread that way, because an
 * address in this product is never spelled out.
 *
 * Above five, a word is harder to read than the digit and the collision is
 * unlikely anyway (no screen offers a "compartment fourteen"), so it falls back.
 *
 * See the copy rules in .claude/rules/general.md.
 */
const COUNT_WORDS = ["No", "One", "Two", "Three", "Four", "Five"] as const;

export function spellCount(n: number): string {
  return COUNT_WORDS[n] ?? String(n);
}

/** Same, lowercased, for counts that land mid-sentence. */
export function spellCountLower(n: number): string {
  return spellCount(n).toLowerCase();
}
